var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('vue-document-editor',{ref:"vueDocumentEditor",staticClass:"print-template",attrs:{"content":_vm.content},on:{"update:content":[function($event){_vm.content=$event},_vm.getTemplates]}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }